// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.content_title_span[data-v-3e33b7cf] {\n  font-size: 18px;\n  font-weight: 500;\n  color: #000;\n}\n.bul_list_sm >li[data-v-3e33b7cf]:before {\n  content: none;\n}\n", ""]);
// Exports
module.exports = exports;
